import React, { useState, useEffect } from 'react';
import { Grid } from "@mui/material";
import MKTypography from "../../../../components/MKTypography";
import MKBox from "../../../../components/MKBox";
import MKButton from "../../../../components/MKButton";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { handleSubscribe, taxAddressCheck, handleSubscribeTerminal } from "../../../../providers/planService"
import { getAuth } from "firebase/auth";
import WarningIcon from '@mui/icons-material/Warning';
import TextField from '@mui/material/TextField';
import currencyConverter from '../../../../helpers/currencyConverter';
import { withStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { getAllowedStore } from '../../../../providers/addonGrow'
import clsx from "clsx";
import Lottie from "lottie-react";
import growLoader from "../../../../assets/animation/growLoader.json";
import checkCircle from "../../../../assets/images/check_circle.svg"
import { downloadInvoice } from "../../../../providers/invoiceService";

const MyTextField = withStyles(() => ({
    root: {
        "&.MuiInputLabel": {
            fontFamily: "OpenSansRegular"
        },
        "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
            color: "#F7931E",
            fontSize: "14px",
        },
        "& .MuiInput-root": {
            fontSize: "14px",
            fontFamily: "OpenSansMedium"
        },
        "& .MuiFormHelperText-root": {
            color: "#FF4040",
            fontFamily: "OpenSansMedium",
            fontSize: "12px",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: "#FF4040",
            fontSize: "12px",
            fontFamily: "OpenSansRegular",
        }

    }
}))(TextField)

const MyInputLabel = withStyles(() => ({
    root: {
        "& .MuiInputLabel-asterisk": {
            color: "#F7931E",
        }
    }
}))(InputLabel)

const MyFormField = withStyles(() => ({
    root: {
        "& .MuiInput-root": {
            fontSize: "14px",
            fontFamily: "OpenSansMedium"
        },
        "& .MuiInputBase-input:focus": {
            backgroundColor: "#FFFFFF"
        }
    }
}))(FormControl)

const iconStyles = {
    selectIcon: {
        color: "#8C9196"
    }
};

const CustomExpandMore = withStyles(iconStyles)(
    ({ className, classes, ...rest }) => {
        return (
            <KeyboardArrowDownIcon
                {...rest}
                className={clsx(className, classes.selectIcon)}
            />
        );
    }
);


const AddOnModal = ({ planDetails, setModal, merchName, getAddonsAfter }) => {

    // Helper function to get Firebase token
    const getToken = () => {
        return getAuth()
            .currentUser?.getIdToken(true)
            .then((idToken) => {
                return idToken;
            });
    };

    const [value, setValue] = useState('');
    const [error, setError] = useState(false);
    const [storeError, setStoreError] = useState(false);

    const [helperText, setHelperText] = useState('');

    const [message, setMessage] = useState('');
    const [errorResponse, setErrorResponse] = useState(false);
    const [quantityValue, setQuantityValue] = useState(1);
    const [typeSelected, setTypeSelected] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [qtyError, setQtyError] = useState(false);
    const [textFieldsShow, setTextFieldShow] = useState(true);
    const [storeList, setStoreList] = useState([]);
    const [oneTimeAmount, setOneTimeAmount] = useState('');
    const [recurringAmount, setRecurringAmount] = useState('');

    // Helper function to handle Razorpay checkout for addon subscriptions and one-time purchases
    const handleRazorpayCheckout = async (addonResult, addonName, addonCode, popupData) => {
        try {
            // Check if Razorpay is loaded
            if (typeof window.Razorpay === 'undefined') {
                setMessage("Razorpay is not loaded. Please refresh the page.");
                setErrorResponse(true);
                return;
            }

            // Set up Razorpay options based on subscription or order type
            const options = {
                key: addonResult.razorpay_key,
                name: 'ShelfPerks',
                description: `${addonName} Add-on`,
                subscription_id: addonResult.subscription_id,
                handler: async function (response) {
                    try {
                        // All addons use subscription callback (both one-time and recurring)
                        const callbackResult = await fetch(window.spconfig?.config.billingUrl + "/billing/razorpay/subscription_callback", {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + await getToken()
                            },
                            body: JSON.stringify({
                                razorpay_subscription_id: response.razorpay_subscription_id,
                                razorpay_payment_id: response.razorpay_payment_id,
                                razorpay_signature: response.razorpay_signature,
                                sp_code: addonCode,
                                type: 'addon'
                            })
                        });

                        const callbackData = await callbackResult.json();
                        console.log('Addon subscription callback response:', callbackData);

                        if (callbackData.success) {
                            popupData['addOnId'] = callbackData.payment_id
                            setMessage(`${addonName} addon activated successfully!`);
                            setErrorResponse(false); // Using same state for success message
                            setStatusData(popupData)
                            setShowConfirmation(true)
                            getAddonsAfter()
                            setIsLoading(true)
                            setTimeout(() => {
                                // setModal(false);
                                // window.location.reload(); // Refresh to show new addon
                                setIsLoading(false)

                            }, 2000);
                        } else {
                            setMessage(callbackData.message || "Addon activation failed");
                            setErrorResponse(true);
                        }
                    } catch (error) {
                        console.error('Addon callback error:', error);
                        setMessage("Failed to activate addon");
                        setErrorResponse(true);
                    }
                },
                prefill: {
                    name: 'User', // You can get this from profile if available
                    email: 'user@example.com',
                    contact: '9999999999'
                },
                theme: {
                    color: '#50B748'
                },
                modal: {
                    ondismiss: function () {
                        setMessage("Addon purchase cancelled");
                        setErrorResponse(true);
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (error) {
            console.error('Razorpay checkout error:', error);
            setMessage("Failed to open payment window");
            setErrorResponse(true);
        }
    };


    useEffect(() => {
        setOneTimeAmount(planDetails['onetime']?.price);
        setRecurringAmount(planDetails['recurring']?.price);
        async function getStores() {
            const storeList = await getAllowedStore();
            setStoreList(storeList.data.ResponseData.data);
        }
        getStores();
    }, [])





    const handleRadioChange = (event) => {
        const choice = event.target.value;
        setValue(choice);
        setError(false);
        setHelperText('');
        if (choice === '') {
            setTypeSelected(false)
        } else {
            setTotalAmount(planDetails[choice].price)
            setTypeSelected(true);
            if (!planDetails[choice].price || planDetails[choice].price === 0) {
                setTextFieldShow(false)
            } else {
                setTextFieldShow(true)
            }

        }
    };


    const addUserDet = [
        'Give more users access to your Shelfperks Store Operating System.',
        'One time add-on will be billed for a single time only for a month. Recurring add-on will be billed the same day of every billing cycle.'
    ]

    const addTermDet = [
        'Increasing the terminals means being able to ring up more customers.',
        'Shorter waiting lines make happy customers!',
        'One time add-on will be billed for a single time only for a month. Recurring add-on will be billed the same day of every billing cycle.',
    ]

    const addStoreWebsite = [
        'Increase your revenue with online sales.',
        'You can take your store online instantly.',
        'Integrated with in-store/online inventory updates and order fulfillment.',
        'Make your customers happy with convenient pickups and delivery options.'

    ]

    const handleSubmitTerminal = async (event) => {
        event.preventDefault();
        if (allowedStoreKey === '' || allowedStoreKey === undefined || allowedStoreKey === null) {
            setStoreError(true);
            return;
        }
        if (value === '') {
            setError(true);
            setHelperText('Please select an option.');
            return;
        } else {
            const checkTax = await taxAddressCheck()
            if (checkTax.status === 200) {
                if ((checkTax.data.tax_enabled !== 0)) {
                    setMessage(checkTax.data.tax_status)
                    setErrorResponse(true);
                    return;
                }
            }
            const addOnCode = planDetails[value].code;
            const addonName = planDetails[value].name || 'Terminal Addon';
            try {
                const result = await handleSubscribeTerminal([{ "sp_code": addOnCode, "quantity": quantityValue }], allowedStoreKey);
                console.log('Terminal addon subscription result:', result.data);

                if (result.data.success && result.data.subscription_id) {
                    // Use Razorpay JavaScript SDK instead of redirect
                    const storeDet = storeList.find((ele) => ele.key === allowedStoreKey)
                    const popupData = {
                        title: "Additional Terminal added successfully!",
                        type: "Creation",
                        addOnName: "Terminal",
                        addOnType: addOnCode.includes("-1") ? "one_time" : "Recurring",
                        storeName: storeDet?.storeName ? storeDet?.storeName : ""
                    }
                    await handleRazorpayCheckout(result.data, addonName, addOnCode, popupData);
                } else {
                    setMessage(result.data.message || 'Failed to create terminal addon subscription');
                    setErrorResponse(true);
                }
            } catch (err) {
                console.error('Terminal addon subscription error:', err);
                setMessage('Cannot use addons from Free plan.')
                setErrorResponse(true);
                return;
            }


        }
    };

    const handleSubmitUser = async (event) => {
        event.preventDefault();

        if (value === '') {
            setError(true);
            setHelperText('Please select an option.');
            return;
        } else if (quantityValue <= 0 || quantityValue === '') {
            setQtyError(true);
            return;
        }

        else {
            const checkTax = await taxAddressCheck()
            if (checkTax.status === 200) {
                if ((checkTax.data.tax_enabled !== 0)) {
                    setMessage(checkTax.data.tax_status)
                    setErrorResponse(true);
                    return;
                }
            }
            const addOnCode = planDetails[value].code;
            const addonName = planDetails[value].name || 'User Addon';
            try {
                const result = await handleSubscribe([{ "sp_code": addOnCode, "quantity": quantityValue }], 'addons');
                console.log('Addon subscription result:', result.data);

                if (result.data.success && result.data.subscription_id) {
                    // Use Razorpay JavaScript SDK instead of redirect
                    const popupData = {
                        title: "Additional Users added successfully!",
                        type: "Creation",
                        addOnName: "User",
                        userQty: quantityValue,
                        addOnType: addOnCode.includes("-1") ? "one_time" : "Recurring"
                    }
                    await handleRazorpayCheckout(result.data, addonName, addOnCode, popupData);
                } else {
                    setMessage(result.data.message || 'Failed to create addon subscription');
                    setErrorResponse(true);
                }
            } catch (err) {
                console.error('Addon subscription error:', err);
                setMessage('Cannot use addons from Free plan.')
                setErrorResponse(true);
                return;
            }


        }
    };

    const handleSubmitWebsiteAddon = async (event) => {
        event.preventDefault();

        const checkTax = await taxAddressCheck();
        if (checkTax.status === 200) {
            if ((checkTax.data.tax_enabled !== 0)) {
                setMessage(checkTax.data.tax_status)
                setErrorResponse(true);
                return;
            }
        }

        const addOnCode = planDetails['recurring'].code;
        const addonName = 'Store Website Addon';
        try {
            const result = await handleSubscribe([{ "sp_code": addOnCode, "quantity": 1 }], 'addons');
            if (result.data.success && result.data.subscription_id) {
                // Use Razorpay JavaScript SDK instead of redirect
                const popupData = {
                    title: "Store Website Addon added successfully!",
                    type: "Creation",
                    addOnName: "Store Website",
                    addOnType: addOnCode.includes("-1") ? "one_time" : "Recurring"
                }
                await handleRazorpayCheckout(result.data, addonName, addOnCode, popupData);
            } else {
                setMessage(result.data.message || 'Failed to create Stoe website addon subscription');
                setErrorResponse(true);
            }
        } catch (err) {
            console.error('Addon subscription error:', err);
            setMessage('Cannot use addons from Free plan.')
            setErrorResponse(true);
            return;
        }
    }


    const preventMinusAndPeriod = (e) => {
        if (e.code === 'Minus' || e.code === 'Period' || e.code === 'KeyE') {
            e.preventDefault();
        }
    };

    const handleClose = () => {
        setModal(false);
    }

    const updateQuantity = (e) => {
        setQtyError(false);
        const qty = e.target.value;
        if (value === '') {
            setError(true);
            setHelperText('Please select an option.');
            return;
        }
        setQuantityValue(qty)
        setTotalAmount((qty * planDetails[value].price))
    }

    // const [responseError, setResponseError] = useState(false);
    const [allowedStoreKey, setAllowedStoreKey] = useState('');

    const handleAllowedOption = (event) => {
        setStoreError(false);
        setAllowedStoreKey(event.target.value.key)
    }
    const [isLoading, setIsLoading] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [statusData, setStatusData] = useState({});
    const addonTypeName = (addonName) => {
        if (addonName === 'one_time') {
            return 'One Time';
        } else {
            return 'Recurring'
        }
    }
    const downloadInvoiceData = async () => {

        const subType = statusData.addOnType.toLowerCase() === 'one_time'
            ? 'onetime' : statusData.addOnType.toLowerCase()
        const invoiceData = {
            id: statusData.addOnId,
            type: 'Addon',
            subType: subType
        }
        console.log('invoiceData', invoiceData);
        const result = await downloadInvoice(invoiceData, merchName);
        handleClose();
    }
    return (
        <>
            <div className="addonmodal">
                <div className="overlay"></div>
                <div className="addon-modal-content">
                    <>
                        {!showConfirmation ?
                            <>
                                {!errorResponse ?
                                    <Grid sx={{
                                        p: { lg: "40px", md: "40px", sm: "30px", xs: "20px" },
                                        height: "auto",
                                        mt: { xs: "20px", sm: "20px", md: "20px" }
                                    }}>
                                        <MKTypography fontSize="20px" style={{ color: "#202223", letterSpacing: "0px", textAlign: "left", opacity: 1, }}> <span className="semi-bold">{planDetails.name}</span>
                                        </MKTypography>

                                        {planDetails.name === 'Additional Terminal' ?
                                            <MKBox>
                                                <MKTypography sx={{
                                                    // height: { xl: "260px", lg: "260px", md: "340x", sm: "340px", xs: "340px" },
                                                    overflow: "auto"
                                                }} fontSize="14px" mt="24px" style={{ color: "#202223", letterSpacing: "0.18px", textAlign: "left", opacity: 1, lineHeight: 2 }}>
                                                    <div>



                                                        <div className='addon-content'>

                                                            <div style={{ marginBottom: '30px' }}>
                                                                {addTermDet[0]} <br />
                                                                {addTermDet[1]}

                                                            </div>
                                                            <div>
                                                                {addTermDet[2]}
                                                            </div>
                                                        </div>





                                                        <div style={{ marginTop: '40px', fontFamily: "OpenSansRegular", fontSize: '14px' }}>
                                                            <MKTypography fontSize="14px" mb={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}>

                                                                <FormControl error={error} sx={{ fontSize: '14px' }}>
                                                                    <MKTypography fontSize="16px" mb={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}>Please select a type of addon</MKTypography>

                                                                    {/* <FormLabel id="demo-row-radio-buttons-group-label" color='success'>Please select a type of addon</FormLabel> */}
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        onChange={handleRadioChange}
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            fontFamily: "OpenSansRegular",
                                                                        }}
                                                                    >
                                                                        {planDetails.onetime?.code ?
                                                                            <FormControlLabel

                                                                                mb={'40px'} value="onetime" control={<Radio sx={{
                                                                                    color: '#50B748',
                                                                                    fontSize: '14px',
                                                                                    fontFamily: "OpenSansRegular",
                                                                                    '&.Mui-checked': {
                                                                                        color: '#50B748',
                                                                                    },

                                                                                }} />} label="One Time" />
                                                                            : ""}
                                                                        <MKTypography fontSize="14px" sx={{ marginRight: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>( <span className="semi-bold">{currencyConverter(planDetails.onetime.price)}</span>)</MKTypography>

                                                                        {planDetails.recurring?.code ?
                                                                            <FormControlLabel mb={'40px'} value="recurring" control={<Radio sx={{
                                                                                color: '#50B748',
                                                                                fontSize: '14px',
                                                                                fontFamily: "OpenSansRegular",
                                                                                '&.Mui-checked': {
                                                                                    color: '#50B748',
                                                                                },
                                                                            }} />} label="Recurring Monthly" />
                                                                            : ""}
                                                                        <MKTypography fontSize="14px" sx={{ marginRight: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>( <span className="semi-bold">{currencyConverter(planDetails.recurring.price)}</span>)</MKTypography>

                                                                    </RadioGroup>
                                                                    <FormHelperText>{helperText}</FormHelperText>
                                                                </FormControl>
                                                            </MKTypography>
                                                        </div>

                                                        <Grid>
                                                            <MKTypography className="semi-bold" fontSize="16px" sx={{ marginTop: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>At which location do you want to use this terminal?</MKTypography>

                                                            <Grid item container sm={9}>

                                                                <MyFormField required fullWidth variant="standard" error={storeError}>
                                                                    <MyInputLabel style={{ fontFamily: "OpenSansRegular" }}>Store Location</MyInputLabel>

                                                                    <Select
                                                                        variant="standard"
                                                                        labelId="demo-simple-select-label"
                                                                        id="demo-simple-select"
                                                                        label="Store Location"
                                                                        name="location"
                                                                        IconComponent={CustomExpandMore}

                                                                        onChange={handleAllowedOption}
                                                                        sx={{
                                                                            width: '380px',
                                                                            marginTop: '20px'
                                                                        }}
                                                                    >
                                                                        {storeList.map((element) => <MenuItem key={element.key} value={element} sx={{ fontFamily: "OpenSansRegular" }}>{element.storeName}</MenuItem>)}


                                                                    </Select>
                                                                    <FormHelperText>{storeError ? "Please select a store" : ''}</FormHelperText>
                                                                </MyFormField>

                                                            </Grid>
                                                        </Grid>
                                                    </div>


                                                </MKTypography>
                                                <Grid lg={12} sx={{ mt: '60px', mb: '30px', justifyContent: { md: 'start', sm: 'center', xs: 'center' }, }} container item>
                                                    <MKBox sx={{ display: "inline-block", }}>
                                                        <MKButton
                                                            variant="outlined"
                                                            color="primary"
                                                            className="upgrade"
                                                            size="medium"
                                                            sx={{
                                                                width: '100px',
                                                                height: '40px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                color: "#50B748",
                                                                borderColor: "#50B748",
                                                                mr: "30px",
                                                                verticalAlign: "middle",
                                                                lineHeight: 1.5,
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleClose}
                                                        >
                                                            Cancel
                                                        </MKButton>
                                                        <MKButton
                                                            variant="contained"
                                                            color="primary"
                                                            size="medium"
                                                            className="upgrade"
                                                            sx={{
                                                                ':hover': {
                                                                    bgcolor: '#3CAC33',
                                                                    color: '#FFFFFF',

                                                                },
                                                                width: '100px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                verticalAlign: "middle",
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleSubmitTerminal}
                                                        >
                                                            Buy now
                                                        </MKButton>
                                                    </MKBox>
                                                </Grid>
                                            </MKBox>
                                            : ""
                                        }

                                        {planDetails.name === 'Additional User' ?
                                            <MKBox>
                                                <MKTypography sx={{
                                                    // height: { xl: "260px", lg: "260px", md: "340x", sm: "340px", xs: "340px" },
                                                    overflow: "auto"
                                                }} fontSize="14px" mt="24px" style={{ color: "#202223", letterSpacing: "0.18px", textAlign: "left", opacity: 1, lineHeight: 2 }}>
                                                    <div>



                                                        <div className='addon-content'>

                                                            <div style={{ marginBottom: '30px' }}>
                                                                {addUserDet[0]}

                                                            </div>
                                                            <div>
                                                                {addUserDet[1]}
                                                            </div>
                                                        </div>





                                                        <div style={{ marginTop: '40px', fontFamily: "OpenSansRegular", fontSize: '14px' }}>
                                                            <MKTypography fontSize="14px" mb={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}>

                                                                <FormControl error={error} sx={{ fontSize: '14px' }}>
                                                                    <MKTypography fontSize="16px" mb={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}>Please select a type of addon</MKTypography>

                                                                    {/* <FormLabel id="demo-row-radio-buttons-group-label" color='success'>Please select a type of addon</FormLabel> */}
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        onChange={handleRadioChange}
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            fontFamily: "OpenSansRegular",
                                                                        }}
                                                                    >
                                                                        {planDetails.onetime?.code ?
                                                                            <FormControlLabel

                                                                                mb={'40px'} value="onetime" control={<Radio sx={{
                                                                                    color: '#50B748',
                                                                                    fontSize: '14px',
                                                                                    fontFamily: "OpenSansRegular",
                                                                                    '&.Mui-checked': {
                                                                                        color: '#50B748',
                                                                                    },

                                                                                }} />} label="One Time" />
                                                                            : ""}
                                                                        <MKTypography fontSize="14px" sx={{ marginRight: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>( <span className="semi-bold">{currencyConverter(planDetails.onetime.price)}</span>)</MKTypography>

                                                                        {planDetails.recurring?.code ?
                                                                            <FormControlLabel mb={'40px'} value="recurring" control={<Radio sx={{
                                                                                color: '#50B748',
                                                                                fontSize: '14px',
                                                                                fontFamily: "OpenSansRegular",
                                                                                '&.Mui-checked': {
                                                                                    color: '#50B748',
                                                                                },
                                                                            }} />} label="Recurring Monthly" />
                                                                            : ""}
                                                                        <MKTypography fontSize="14px" sx={{ marginRight: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>( <span className="semi-bold">{currencyConverter(planDetails.recurring.price)}</span>)</MKTypography>

                                                                    </RadioGroup>
                                                                    <FormHelperText>{helperText}</FormHelperText>
                                                                </FormControl>
                                                            </MKTypography>
                                                        </div>

                                                        <Grid>
                                                            <Grid item container>
                                                                <Grid xs={10} sm={4} md={3} lg={2}>
                                                                    <MyTextField
                                                                        margin="normal"

                                                                        fullWidth
                                                                        id="userCount"
                                                                        label="# of users"
                                                                        name="userCount"
                                                                        type="number"
                                                                        variant="standard"
                                                                        error={qtyError}
                                                                        helperText={qtyError ? 'Enter a valid quantity' : ''}
                                                                        value={quantityValue}
                                                                        onKeyPress={preventMinusAndPeriod}
                                                                        onChange={updateQuantity}
                                                                        InputLabelProps={{
                                                                            style: { fontFamily: "OpenSansRegular" }
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid xs={10} sm={6} md={6} lg={8} sx={{ justifyContent: 'center center', verticalAlign: 'bottom' }}>
                                                                    <MKTypography fontSize="16px" pt={4.5} ml={{ lg: '110px', xs: '0px', sm: '50px', md: '50px' }} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}> Sub Total: {currencyConverter(totalAmount)}</MKTypography>

                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </div>


                                                </MKTypography>
                                                <Grid lg={12} sx={{ mt: '60px', mb: '30px', justifyContent: { md: 'start', sm: 'center', xs: 'center' }, }} container item>
                                                    <MKBox sx={{ display: "inline-block", }}>
                                                        <MKButton
                                                            variant="outlined"
                                                            color="primary"
                                                            className="upgrade"
                                                            size="medium"
                                                            sx={{
                                                                width: '100px',
                                                                height: '40px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                color: "#50B748",
                                                                borderColor: "#50B748",
                                                                mr: "30px",
                                                                verticalAlign: "middle",
                                                                lineHeight: 1.5,
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleClose}
                                                        >
                                                            Cancel
                                                        </MKButton>
                                                        <MKButton
                                                            variant="contained"
                                                            color="primary"
                                                            size="medium"
                                                            className="upgrade"
                                                            sx={{
                                                                ':hover': {
                                                                    bgcolor: '#3CAC33',
                                                                    color: '#FFFFFF',

                                                                },
                                                                width: '100px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                verticalAlign: "middle",
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleSubmitUser}
                                                        >
                                                            Buy now
                                                        </MKButton>
                                                    </MKBox>
                                                </Grid>
                                            </MKBox>
                                            : ""
                                        }
                                        {planDetails.name === 'Store Website, Monthly' ?
                                            <MKBox>
                                                <MKTypography sx={{
                                                    // height: { xl: "260px", lg: "260px", md: "340x", sm: "340px", xs: "340px" },
                                                    overflow: "auto"
                                                }} fontSize="14px" mt="24px" style={{ color: "#202223", letterSpacing: "0.18px", textAlign: "left", opacity: 1, lineHeight: 2 }}>
                                                    <div>



                                                        <div className='addon-content'>


                                                            <div style={{ marginBottom: '30px', lineHeight: 2.3 }}>

                                                                <div style={{ marginBottom: '15px' }}>
                                                                    {addStoreWebsite[0]}
                                                                </div>


                                                                <div>
                                                                    {addStoreWebsite[1]}
                                                                </div>

                                                                <div>
                                                                    {addStoreWebsite[2]}
                                                                </div>

                                                                <div>
                                                                    {addStoreWebsite[3]}
                                                                </div>

                                                                <div>
                                                                    {addStoreWebsite[4]}
                                                                </div>



                                                            </div>
                                                        </div>






                                                        <div style={{ marginTop: '40px', fontFamily: "OpenSansRegular", fontSize: '14px' }}>
                                                            <MKTypography fontSize="14px" mb={2} className="semi-bold" style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, fontFamily: "OpenSansRegular", }}>

                                                                <FormControl error={error} sx={{ fontSize: '14px' }}>

                                                                    {/* <FormLabel id="demo-row-radio-buttons-group-label" color='success'>Please select a type of addon</FormLabel> */}
                                                                    <RadioGroup
                                                                        row
                                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                                        name="row-radio-buttons-group"
                                                                        // onChange={handleRadioChange}
                                                                        value={"recurring"}
                                                                        sx={{
                                                                            fontSize: '14px',
                                                                            fontFamily: "OpenSansRegular",
                                                                        }}
                                                                    >
                                                                        {planDetails.recurring?.code ?
                                                                            <FormControlLabel mb={'40px'} value="recurring" control={<Radio sx={{
                                                                                color: '#50B748',
                                                                                fontSize: '14px',
                                                                                fontFamily: "OpenSansRegular",
                                                                                '&.Mui-checked': {
                                                                                    color: '#50B748',
                                                                                },
                                                                            }} />} label="Recurring Monthly" />
                                                                            : ""}
                                                                        <MKTypography fontSize="14px" sx={{ marginRight: '40px' }} style={{ color: "#202223", letterSpacing: "0.16px", textAlign: "left", opacity: 1, lineHeight: 3 }}>( <span className="semi-bold">{currencyConverter(planDetails.recurring.price)}</span>)</MKTypography>

                                                                    </RadioGroup>
                                                                    <FormHelperText>{helperText}</FormHelperText>
                                                                </FormControl>
                                                            </MKTypography>
                                                        </div>
                                                    </div>


                                                </MKTypography>
                                                <Grid lg={12} sx={{ mt: '60px', mb: '30px', justifyContent: { md: 'start', sm: 'center', xs: 'center' }, }} container item>
                                                    <MKBox sx={{ display: "inline-block", }}>
                                                        <MKButton
                                                            variant="outlined"
                                                            color="primary"
                                                            className="upgrade"
                                                            size="medium"
                                                            sx={{
                                                                width: '100px',
                                                                height: '40px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                color: "#50B748",
                                                                borderColor: "#50B748",
                                                                mr: "30px",
                                                                verticalAlign: "middle",
                                                                lineHeight: 1.5,
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleClose}
                                                        >
                                                            Cancel
                                                        </MKButton>
                                                        <MKButton
                                                            variant="contained"
                                                            color="primary"
                                                            size="medium"
                                                            className="upgrade"
                                                            sx={{
                                                                ':hover': {
                                                                    bgcolor: '#3CAC33',
                                                                    color: '#FFFFFF',

                                                                },
                                                                width: '100px',
                                                                fontSize: "14px",
                                                                borderRadius: "4px",
                                                                verticalAlign: "middle",
                                                                textTransform: "capitalize",

                                                            }}
                                                            onClick={handleSubmitWebsiteAddon}
                                                        >
                                                            Buy now
                                                        </MKButton>
                                                    </MKBox>
                                                </Grid>
                                            </MKBox>
                                            : ""
                                        }
                                    </Grid>
                                    :
                                    < Grid sx={{
                                        p: '24px',
                                        // height: "auto",
                                        mt: { xs: "60px", sm: "60px", md: "0px" }
                                    }}>
                                        <MKBox xs={12} sx={{ justifyContent: 'center' }}>
                                            <div style={{ textAlign: 'center' }}> <WarningIcon style={{ color: 'red', width: "52px", height: '50px' }} /> </div>
                                        </MKBox>
                                        <MKBox>
                                            <MKTypography sx={{
                                                // height: { xl: "260px", lg: "260px", md: "340x", sm: "340px", xs: "340px" },
                                                overflow: "auto"
                                            }} fontSize="16px" mt="24px" style={{ color: "#202223", letterSpacing: "0.18px", textAlign: "center", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                <span style={{ fontSize: '20px' }}> Something Went Wrong!</span> <br />


                                            </MKTypography>
                                            <Grid xs={12} lg={12} sx={{ mt: '48px', justifyContent: "Center" }} container item>
                                                <MKBox xs={12} sx={{ display: "inline-block", justifyContent: "Center" }}>
                                                    <MKButton
                                                        variant="text"
                                                        color="primary"
                                                        className="upgrade"
                                                        size="medium"

                                                        sx={{

                                                            fontSize: "14px",
                                                            borderRadius: "4px",
                                                            borderColor: "#50B748",
                                                            verticalAlign: "middle",
                                                            lineHeight: 1.5,
                                                            textTransform: "capitalize",
                                                            background: "#50B748",
                                                            color: "#FFFFFF",
                                                            '&:hover': {
                                                                color: '#FFFFFF',
                                                                backgroundColor: '#3cac33',
                                                            },

                                                        }}
                                                        onClick={handleClose}
                                                    >
                                                        OK
                                                    </MKButton>

                                                </MKBox>
                                            </Grid>
                                        </MKBox>
                                    </Grid>
                                }
                            </>
                            :
                            <>
                                {isLoading ?
                                    <>
                                        <MKTypography sx={{
                                            overflow: "auto"
                                        }} fontSize="20px" className="semi-bold" mt="24px" style={{ color: '#202223', letterSpacing: "0px", textAlign: "center", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                            <span style={{ fontSize: '20px' }}>Please wait...</span> <br />
                                        </MKTypography>

                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} justifyContent="center" display="flex" >
                                            <MKBox
                                                sx={{

                                                    width: "150px",
                                                    height: "150px",
                                                }}>
                                                <Lottie animationData={growLoader} loop={true} />
                                            </MKBox>
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <MKBox xs={12} mt={2} sx={{ justifyContent: 'center' }}>
                                            <div style={{ textAlign: 'center' }}> <img src={checkCircle} alt="check"></img> </div>
                                        </MKBox>
                                        <MKBox>
                                            <MKTypography sx={{
                                                // height: { xl: "260px", lg: "260px", md: "340x", sm: "340px", xs: "340px" },
                                                overflow: "auto"
                                            }} fontSize="20px" className="semi-bold" mt="24px" style={{ color: '#202223', letterSpacing: "0px", textAlign: "center", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                <span style={{ fontSize: '20px' }}> {statusData.title}</span> <br />
                                            </MKTypography>
                                            {statusData.addOnName === 'User' ?
                                                <>
                                                    <Grid item container sx={12} mt={6}>
                                                        <Grid sm={5}>

                                                            {statusData.type === 'Creation' ?
                                                                <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                    Number of Users:
                                                                </MKTypography>
                                                                :
                                                                <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                    Number of Users canceled:
                                                                </MKTypography>
                                                            }
                                                        </Grid>
                                                        <Grid sm={1}>

                                                        </Grid>
                                                        <Grid sm={3}>
                                                            <MKTypography className="semi-bold" fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "left", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                {statusData.userQty}
                                                            </MKTypography>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item container sx={12}>
                                                        <Grid sm={5}>
                                                            <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                Add-on Type:
                                                            </MKTypography>
                                                        </Grid>
                                                        <Grid sm={1}>

                                                        </Grid>
                                                        <Grid sm={3}>
                                                            <MKTypography className="semi-bold" fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "left", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                {addonTypeName(statusData.addOnType)}
                                                            </MKTypography>
                                                        </Grid>

                                                    </Grid>
                                                </>
                                                : ""
                                            }

                                            {statusData.addOnName === 'Terminal' ?
                                                <>
                                                    <Grid item container sx={12} mt={6}>
                                                        <Grid sm={3}>
                                                            <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                To:
                                                            </MKTypography>
                                                        </Grid>
                                                        <Grid sm={1}>

                                                        </Grid>
                                                        <Grid sm={5}>
                                                            <MKTypography className="semi-bold" fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "left", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                {statusData.storeName}
                                                            </MKTypography>
                                                        </Grid>

                                                    </Grid>
                                                    <Grid item container sx={12}>
                                                        <Grid sm={3}>
                                                            <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                Add-on Type:
                                                            </MKTypography>
                                                        </Grid>
                                                        <Grid sm={1}>

                                                        </Grid>
                                                        <Grid sm={3}>
                                                            <MKTypography className="semi-bold" fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "left", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                {addonTypeName(statusData.addOnType)}
                                                            </MKTypography>
                                                        </Grid>

                                                    </Grid>
                                                </>
                                                : ""
                                            }
                                            {statusData.addOnName === 'Store Website' ?
                                                <>
                                                    <Grid item container sx={12} mt={6}>
                                                        <Grid sm={12} style={{ textAlign: 'center' }}>

                                                            {statusData.type === 'Creation' ?
                                                                <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "center", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                    Thank you for the purchase. To set up your store website, please log into your ShelfPerks Merchant Portal and click Sell Online.
                                                                </MKTypography>
                                                                :
                                                                <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "center", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                    Your add-on has been cancelled successfully. To continue selling online, you can upgrade your plan to Plus or Premium Plan.
                                                                </MKTypography>
                                                            }
                                                        </Grid>


                                                    </Grid>
                                                    <Grid item container sx={12} style={{ marginTop: '20px' }}>
                                                        <Grid sm={5} >
                                                            <MKTypography fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "right", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                Add-on Type:
                                                            </MKTypography>
                                                        </Grid>
                                                        <Grid sm={1}>

                                                        </Grid>
                                                        <Grid sm={3}>
                                                            <MKTypography className="semi-bold" fontSize="14px" style={{ color: "#202223", letterSpacing: "0.14px", textAlign: "left", opacity: 1, lineHeight: 2, fontFamily: 'OpenSansRegular' }}>
                                                                {addonTypeName(statusData.addOnType)}
                                                            </MKTypography>
                                                        </Grid>

                                                    </Grid>
                                                </>
                                                : ""
                                            }
                                            <Grid lg={12} sx={{ mt: '50px', justifyContent: { md: 'start', sm: 'center', xs: 'center' }, }} container item>

                                                <MKBox sx={{ display: "inline-block", }}>
                                                    <MKButton
                                                        variant="outlined"
                                                        color="primary"
                                                        className="upgrade"
                                                        size="medium"
                                                        sx={{
                                                            width: '100px',
                                                            height: '40px',
                                                            fontSize: "14px",
                                                            borderRadius: "4px",
                                                            color: "#50B748",
                                                            borderColor: "#50B748",
                                                            mr: "50px",
                                                            ml: { xs: '0px', sm: '30px', md: '30px', lg: '30px' },
                                                            mb: '50px',
                                                            verticalAlign: "middle",
                                                            lineHeight: 1.5,
                                                            textTransform: "capitalize",
                                                        }}
                                                        onClick={handleClose}
                                                    >
                                                        Close
                                                    </MKButton>
                                                    <MKButton
                                                        variant="contained"
                                                        color="primary"
                                                        size="medium"
                                                        className="upgrade"
                                                        sx={{
                                                            ':hover': {
                                                                bgcolor: '#3CAC33',
                                                                color: '#FFFFFF',

                                                            },
                                                            width: 'auto',
                                                            fontSize: "14px",
                                                            borderRadius: "4px",
                                                            verticalAlign: "middle",
                                                            mb: '50px',
                                                            textTransform: "capitalize",
                                                        }}
                                                        onClick={downloadInvoiceData}
                                                    >
                                                        Download Invoice
                                                    </MKButton>
                                                </MKBox>
                                            </Grid>



                                        </MKBox>
                                    </>
                                }
                            </>
                        }
                    </>
                </div>
            </div>

        </>
    )
}

export default AddOnModal

{/* 

// {planDetails.name === 'Additional Terminal' ?
//                         <div className='addon-content'>

//                             <div>
//                                 {addTermDet[0]}
//                             </div>
//                             <div>
//                                 {addTermDet[1]}
//                             </div>
//                             <div>
//                                 {addTermDet[2]}
//                             </div>
//                             <div>
//                                 {addTermDet[3]}
//                             </div>

//                         </div>
//                         : ""}

//                                     }


 */}
